(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alankrit-build-your-box"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alankrit-bundle-box')) {
  customElements.define('alankrit-bundle-box', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.picks = this.picks || [];
      this.busy = false;
      this.loadingMore = false;
      this.loadedPages = this.loadedPages || new Set();
      this.autoLoadPaused = false;
      this.needsCartReview = this.needsCartReview || false;
      this.msg = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.listeners = new AbortController();
      this.addEventListener('click', event => this.handleClick(event), { signal: this.listeners.signal });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-variant]')) return;
        const card = event.target.closest('[data-product]');
        const option = event.target.selectedOptions[0];
        const image = card.querySelector('.ab-photo img');
        if (image && option && option.dataset.photo) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = option.dataset.photo;
        }
        this.say('');
        this.renderBox();
      }, { signal: this.listeners.signal });
      this.renderBox();
      const tray = this.querySelector('.ab-box');
      const resize = () => this.style.setProperty('--tray-height', `${tray.offsetHeight + 24}px`);
      resize();
      if ('ResizeObserver' in window) {
        this.trayObserver = new ResizeObserver(resize);
        this.trayObserver.observe(tray);
      }
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.classList.toggle('ab-visible', entries[0].isIntersecting);
        });
        this.visibilityObserver.observe(this);
      } else {
        this.classList.add('ab-visible');
      }
      this.setupInfiniteScroll();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.pageRequest?.abort();
      this.trayObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.infiniteObserver?.disconnect();
      this.initialized = false;
    }

    get root() {
      return (this.dataset.root || '/').replace(/\/?$/, '/');
    }

    say(message) {
      this.querySelector('[data-status]').textContent = message;
    }

    setupInfiniteScroll() {
      const sentinel = this.querySelector('[data-infinite]');
      if (!sentinel || !sentinel.dataset.nextUrl) return;
      if ('IntersectionObserver' in window) {
        this.infiniteObserver = new IntersectionObserver(entries => {
          if (!this.autoLoadPaused && entries.some(entry => entry.isIntersecting)) {
            this.loadMoreProducts();
          }
        }, { rootMargin: '0px 0px 400px 0px', threshold: 0 });
        this.infiniteObserver.observe(sentinel);
      } else {
        // Older browsers can still load products without numbered pagination.
        this.querySelector('[data-load-more]').hidden = false;
      }
    }

    async loadMoreProducts() {
      const sentinel = this.querySelector('[data-infinite]');
      const next = sentinel?.dataset.nextUrl;
      if (this.busy || this.loadingMore || !next) return;
      const url = new URL(next, window.location.href);
      if (this.loadedPages.has(url.href)) {
        sentinel.dataset.nextUrl = '';
        sentinel.hidden = true;
        this.infiniteObserver?.unobserve(sentinel);
        return;
      }
      this.loadingMore = true;
      this.autoLoadPaused = false;
      this.infiniteObserver?.unobserve(sentinel);
      const catalog = this.querySelector('[data-catalog]');
      const status = this.querySelector('[data-loading-status]');
      const retry = this.querySelector('[data-load-more]');
      catalog.setAttribute('aria-busy', 'true');
      status.textContent = this.msg.loading;
      retry.hidden = true;
      retry.disabled = true;
      this.pageRequest = new AbortController();
      let loaded = false;
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: this.pageRequest.signal });
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.getElementById(this.id)?.querySelector('[data-catalog]');
        const incomingGrid = incoming?.querySelector('.ab-grid');
        const grid = catalog.querySelector('.ab-grid');
        if (!incomingGrid || !grid) throw new Error();
        if (!this.isConnected) return;
        const existing = new Set(Array.from(grid.querySelectorAll('[data-product]'), card => card.dataset.product));
        const cards = Array.from(incomingGrid.children).filter(card => {
          if (!card.dataset.product) return false;
          if (existing.has(card.dataset.product)) return false;
          existing.add(card.dataset.product);
          return true;
        });
        // Append cards to the existing grid; selected pieces stay in this.picks.
        grid.append(...cards);
        this.loadedPages.add(url.href);
        let nextUrl = incoming.querySelector('[data-infinite]')?.dataset.nextUrl || '';
        if (nextUrl && this.loadedPages.has(new URL(nextUrl, window.location.href).href)) nextUrl = '';
        sentinel.dataset.nextUrl = nextUrl;
        sentinel.hidden = !nextUrl;
        status.textContent = '';
        retry.textContent = this.msg.loadMore;
        loaded = true;
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.autoLoadPaused = true;
          status.textContent = this.msg.loadError;
          retry.textContent = this.msg.retry;
          retry.hidden = false;
        }
      } finally {
        this.loadingMore = false;
        catalog.setAttribute('aria-busy', 'false');
        retry.disabled = this.busy;
        if (this.isConnected) {
          this.renderBox();
          if (loaded && sentinel.dataset.nextUrl) {
            // Re-observing also fills tall screens if the marker is still visible.
            if (this.infiniteObserver) this.infiniteObserver.observe(sentinel);
            else retry.hidden = false;
          }
        }
      }
    }

    // A single-variant product uses its card data, with no hidden dropdown.
    getVariant(card) {
      const select = card.querySelector('[data-variant]');
      if (select) {
        const option = select.selectedOptions[0];
        if (!option) return null;
        return { id: option.value, available: option.dataset.available === 'true', name: option.dataset.name, image: option.dataset.image };
      }
      return {
        id: card.dataset.defaultVariant,
        available: card.dataset.defaultAvailable === 'true',
        name: card.dataset.defaultName,
        image: card.dataset.defaultImage
      };
    }

    renderBox() {
      const slots = this.querySelector('[data-slots]');
      slots.replaceChildren();
      for (let index = 0; index < 4; index++) {
        const slot = document.createElement('div');
        slot.className = 'ab-slot';
        const pick = this.picks[index];
        if (pick) {
          slot.classList.add('ab-filled');
          slot.title = pick.title + (pick.name && pick.name !== 'Default Title' ? ` · ${pick.name}` : '');
          if (pick.image) {
            const image = document.createElement('img');
            image.src = pick.image;
            image.alt = pick.title;
            image.width = 44;
            image.height = 44;
            slot.append(image);
          }
          const title = document.createElement('p');
          title.textContent = pick.title;
          slot.append(title);
          if (pick.name && pick.name !== 'Default Title') {
            const variant = document.createElement('small');
            variant.textContent = pick.name;
            slot.append(variant);
          }
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.remove = String(index);
          remove.textContent = this.msg.remove;
          remove.setAttribute('aria-label', `${this.msg.remove}: ${slot.title}`);
          remove.disabled = this.busy;
          slot.append(remove);
        } else {
          slot.textContent = `${this.msg.slot} ${index + 1}`;
        }
        slots.append(slot);
      }
      this.querySelector('[data-progress]').value = this.picks.length;
      this.querySelector('[data-count]').textContent = `${this.picks.length} / 4`;
      this.querySelectorAll('[data-add]').forEach(button => {
        const card = button.closest('[data-product]');
        const chosen = this.picks.filter(pick => pick.product === card.dataset.product).length;
        const variant = this.getVariant(card);
        card.classList.toggle('ab-selected', chosen > 0);
        card.dataset.selectedLabel = `${chosen} ${this.msg.selected}`;
        button.disabled = this.busy || this.needsCartReview || this.picks.length >= 4 || !variant?.id || !variant.available || (this.dataset.repeat !== 'true' && chosen > 0);
      });
      this.querySelectorAll('[data-variant]').forEach(select => {
        select.disabled = this.busy || !Array.from(select.options).some(option => option.dataset.available === 'true');
      });
      const button = this.querySelector('[data-submit]');
      button.disabled = this.busy || (!this.needsCartReview && this.picks.length !== 4);
      button.setAttribute('aria-busy', String(this.busy));
      button.textContent = this.busy ? this.msg.busy : this.needsCartReview ? this.msg.review : this.picks.length === 4 ? this.msg.submit : `${this.msg.choose} (${this.picks.length}/4)`;
      this.querySelector('[data-review]').hidden = !this.needsCartReview;
      const more = this.querySelector('[data-load-more]');
      if (more) more.disabled = this.busy || this.loadingMore;
    }

    async handleClick(event) {
      const button = event.target.closest('button');
      if (this.busy) {
        if (button) event.preventDefault();
        return;
      }
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-load-more')) {
        await this.loadMoreProducts();
        return;
      }
      if (button.hasAttribute('data-add')) {
        if (this.picks.length >= 4) { this.say(this.msg.full); return; }
        const card = button.closest('[data-product]');
        const variant = this.getVariant(card);
        if (!variant?.id || !variant.available) return;
        if (this.dataset.repeat !== 'true' && this.picks.some(pick => pick.product === card.dataset.product)) {
          this.say(this.msg.repeat);
          return;
        }
        this.picks.push({ id: variant.id, product: card.dataset.product, title: card.dataset.title, name: variant.name, image: variant.image });
        this.say('');
        this.renderBox();
      } else if (button.hasAttribute('data-remove')) {
        this.picks.splice(Number(button.dataset.remove), 1);
        if (!this.needsCartReview) this.say('');
        this.renderBox();
      } else if (button.hasAttribute('data-submit')) {
        if (this.needsCartReview) {
          window.location.assign(this.root + 'cart');
        } else {
          await this.submitBox();
        }
      }
    }

    async submitBox() {
      if (this.busy || this.needsCartReview || this.picks.length !== 4) return;
      this.busy = true;
      this.renderBox();
      this.say('');
      try {
        const quantities = new Map();
        this.picks.forEach(pick => quantities.set(pick.id, (quantities.get(pick.id) || 0) + 1));
        const items = Array.from(quantities, ([id, quantity]) => ({ id: Number(id), quantity }));
        // One bulk add request. Shopify checks current stock and calculates prices.
        const response = await fetch(this.root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          // A stock error can still add some items. Avoid a duplicate retry.
          this.needsCartReview = true;
          this.say([typeof data.description === 'string' ? data.description : this.msg.error, this.msg.uncertain].join(' '));
          return;
        }
        const code = this.dataset.discount.trim();
        const cart = this.root + 'cart';
        // Optional existing Shopify code. Automatic discounts need no code here.
        window.location.assign(code ? `${this.root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cart)}` : cart);
      } catch (error) {
        // Do not retry a POST automatically: the server may already have added it.
        this.needsCartReview = true;
        this.say(this.msg.uncertain);
      } finally {
        this.busy = false;
        if (this.isConnected) this.renderBox();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
